import type { ReactElement } from "react";
import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { initialActionsPanelFilters } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/initialState";
import { CONTACTS_SEARCH_TABLE_INITIAL_PAGE } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/table";
import { actionsPanelFiltersChangedAction } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/action-creators";
import {
    selectActionsPanelFilters,
    selectContactsResultsAreBeingFetched,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import type { ActionsPanelFilters } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import { selectLoadingContactStatus } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

import ContactRevealStatusDropdown from "../../../components/contacts/ContactRevealStatusDropdown/ContactRevealStatusDropdown";

const ContactRevealStatusDropdownContainer = (): ReactElement => {
    const dispatch = useDispatch();

    const actionsPanelFilters = useSelector(selectActionsPanelFilters);

    const isLoadingContactsResults = useSelector(selectContactsResultsAreBeingFetched);
    const isLoadingContactStatus = useSelector(selectLoadingContactStatus);

    const handleActionsPanelFilters = useCallback((newFilters: Partial<ActionsPanelFilters>) => {
        companyAnalysisTrackingService.trackRevealedStatusFilter(Object.keys(newFilters));

        const includeOnlyRevealed = Boolean(
            newFilters.includeOnlyRevealed || newFilters.includeOnlyExported || newFilters.excludeExported,
        );

        dispatch(
            actionsPanelFiltersChangedAction({
                ...initialActionsPanelFilters,
                ...newFilters,
                includeOnlyRevealed,
                page: CONTACTS_SEARCH_TABLE_INITIAL_PAGE,
            }),
        );
    }, []);

    return (
        <ContactRevealStatusDropdown
            filters={actionsPanelFilters}
            isDisabled={isLoadingContactStatus || isLoadingContactsResults}
            onChange={handleActionsPanelFilters}
        />
    );
};

export default ContactRevealStatusDropdownContainer;
